



























import { Component, Vue } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'


interface SuccessWareJobQuery {
    firstName: string|null;
    lastName: string|null;
    phone: string|null;
    phone2: string|null;
    phone3: string|null;
    phone4: string|null;
    address1: string|null;
    address2: string|null;
    city: string|null;
    state: string|null;
    zip: string|null;
}


interface SuccessWareData extends Response {
    data: SuccessWareJobQuery|null;
}


interface SuccessWarePayload {
    pulsemAccountId: number|null;
    jobId: string|null;
    jobNumber: string|null;
}


@Component({
    components: {
        AccountIdInput
    }
})
export default class SuccessWareJobLookup extends Vue {
    errorMessage: string|null = null
    pulsemAccountId: number|null = null
    jobId: string|null = null
    jobNumber: string|null = null
    successWareJobData: SuccessWareData|null = null

    /**
     * This function is responsible for compiling the input and handing it to the post request. We want to
     * grab the proper payload variables and compile them into an interface of SuccessWareInputPayload. This payload
     * will contain all necessary information needed for the endpoint. This includes a pulsem account id of an account
     * who uses SuccessWare, this includes the jobId of the SW job or the jobNumber.
     * @returns { SuccessWarePayload }
     */
    get payload(): SuccessWarePayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            jobId: this.jobId,
            jobNumber: this.jobNumber
        }
    }

    /**
     * This functions retrieves the pertinent data for the sw job using a location id, and a job id or number. If
     * an error occurs on the backend we need to null both job id and number and also present the user with a
     * relevant error message.
     */
    async getSuccessWareJob() {
        try {
            this.errorMessage = ''
            this.successWareJobData = null
            this.successWareJobData = await (await request.post(
                '/support/successware-job-load', this.payload) as SuccessWareData)
        } catch(e) {
            this.jobId = null
            this.jobNumber = null
            this.errorMessage = e.message
        }
    }
}
